import { ValueUpdater } from '../../../../valueUpdater';
export class PartV11 {
    static constructFromPlainObjectList(objList) {
        const partsList = [];
        if (objList && Array.isArray(objList)) {
            for (const obj of objList) {
                partsList.push(PartV11.constructFromPlainObject(obj));
            }
        }
        return partsList;
    }
    static constructFromPlainObject(source) {
        const part = new PartV11(source.mainGroup, source.subgroup, source.itemNumber, source.description, source.quantity);
        part.availableQuantity = ValueUpdater.updateNullableNumber(part.availableQuantity, source.availableQuantity);
        part.bmwNetPricePerPart = ValueUpdater.updateNullableNumber(part.bmwNetPricePerPart, source.bmwNetPricePerPart);
        part.bmwPartsOrderingNumber = ValueUpdater.updateNonNullableString(part.bmwPartsOrderingNumber, source.bmwPartsOrderingNumber);
        part.coding = ValueUpdater.updateNonNullableString(part.coding, source.coding);
        part.comment = ValueUpdater.updateNonNullableString(part.comment, source.comment);
        part.dealerNetPricePerPart = ValueUpdater.updateNullableNumber(part.dealerNetPricePerPart, source.dealerNetPricePerPart);
        part.discountPercentage = ValueUpdater.updateNonNullableNumber(part.discountPercentage, source.discountPercentage);
        part.hasClearingFlag = ValueUpdater.updateNonNullableBoolean(part.hasClearingFlag, source.hasClearingFlag);
        part.hasRetentionRequirement = ValueUpdater.updateNonNullableBoolean(part.hasRetentionRequirement, source.hasRetentionRequirement);
        part.invoiceTransparency = ValueUpdater.updateNonNullableString(part.invoiceTransparency, source.invoiceTransparency);
        part.isLocal = ValueUpdater.updateNonNullableBoolean(part.isLocal, source.isLocal);
        part.isSelected = ValueUpdater.updateNonNullableBoolean(part.isSelected, source.isSelected);
        part.positionNumber = ValueUpdater.updateNullableNumber(part.positionNumber, source.positionNumber);
        part.reasonForRetentionRequirement = ValueUpdater.updateNonNullableString(part.reasonForRetentionRequirement, source.reasonForRetentionRequirement);
        part.split = ValueUpdater.updateNullableNumber(part.split, source.split);
        part.suffix = ValueUpdater.updateNullableNumber(part.suffix, source.suffix);
        part.totalCustomerGrossPrice = ValueUpdater.updateNullableNumber(part.totalCustomerGrossPrice, source.totalCustomerGrossPrice);
        part.valueAddedTax = ValueUpdater.updateNullableNumber(part.valueAddedTax, source.valueAddedTax);
        part.vehicle = ValueUpdater.updateNonNullableString(part.vehicle, source.vehicle);
        return part;
    }
    constructor(mainGroup, subgroup, itemNumber, description, quantity) {
        this.mainGroup = mainGroup;
        this.subgroup = subgroup;
        this.itemNumber = itemNumber;
        this.description = description;
        this.quantity = quantity;
        this.availableQuantity = null;
        this.bmwNetPricePerPart = null;
        this.bmwPartsOrderingNumber = '';
        this.coding = '';
        this.comment = '';
        this.dealerNetPricePerPart = null;
        this.discountPercentage = 0;
        this.hasClearingFlag = false;
        this.hasRetentionRequirement = false;
        this.invoiceTransparency = '';
        this.isLocal = false;
        this.isSelected = false;
        this.positionNumber = null;
        this.reasonForRetentionRequirement = '';
        this.split = null;
        this.suffix = null;
        this.totalCustomerGrossPrice = null;
        this.valueAddedTax = null;
        this.vehicle = '';
    }
    getInvoiceTransparency() {
        return this.invoiceTransparency;
    }
    setInvoiceTransparency(invoiceTransparency) {
        this.invoiceTransparency = invoiceTransparency;
    }
    getHasClearingFlag() {
        return this.hasClearingFlag;
    }
    setHasClearingFlag(hasClearingFlag) {
        this.hasClearingFlag = hasClearingFlag;
    }
    getCoding() {
        return this.coding;
    }
    setCoding(coding) {
        this.coding = coding;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getDescription() {
        return this.description;
    }
    setDescription(description) {
        this.description = description;
    }
    getDiscountPercentage() {
        return this.discountPercentage;
    }
    setDiscountPercentage(discountPercentage) {
        this.discountPercentage = discountPercentage;
    }
    getMainGroup() {
        return this.mainGroup;
    }
    getIsLocal() {
        return this.isLocal;
    }
    setIsLocal(isLocal) {
        this.isLocal = isLocal;
    }
    getPartNumber() {
        return this.mainGroup + this.subgroup + this.itemNumber;
    }
    setPartNumber(partNumber) {
        this.mainGroup = partNumber.substring(0, 2);
        this.subgroup = partNumber.substring(2, 4);
        this.itemNumber = partNumber.substring(4);
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getHasRetentionRequirement() {
        return this.hasRetentionRequirement;
    }
    setHasRetentionRequirement(hasRetentionRequirement) {
        this.hasRetentionRequirement = hasRetentionRequirement;
    }
    getReasonForRetentionRequirement() {
        return this.reasonForRetentionRequirement;
    }
    setReasonForRetentionRequirement(reasonForRetentionRequirement) {
        this.reasonForRetentionRequirement = reasonForRetentionRequirement;
    }
    getDealerNetPricePerPart() {
        return this.dealerNetPricePerPart;
    }
    setDealerNetPricePerPart(dealerNetPricePerPart) {
        this.dealerNetPricePerPart = dealerNetPricePerPart;
    }
    getTotalCustomerGrossPrice() {
        return this.totalCustomerGrossPrice;
    }
    setTotalCustomerGrossPrice(totalCustomerGrossPrice) {
        this.totalCustomerGrossPrice = totalCustomerGrossPrice;
    }
    getQuantity() {
        return this.quantity;
    }
    setQuantity(quantity) {
        this.quantity = quantity;
    }
    getAvailableQuantity() {
        return this.availableQuantity;
    }
    setAvailableQuantity(availableQuantity) {
        this.availableQuantity = availableQuantity;
    }
    getBmwNetPricePerPart() {
        return this.bmwNetPricePerPart;
    }
    setBmwNetPricePerPart(bmwNetPricePerPart) {
        this.bmwNetPricePerPart = bmwNetPricePerPart;
    }
    getItemNumber() {
        return this.itemNumber;
    }
    getSplit() {
        return this.split;
    }
    setSplit(split) {
        this.split = split;
    }
    getSuffix() {
        return this.suffix;
    }
    setSuffix(suffix) {
        this.suffix = suffix;
    }
    getSubgroup() {
        return this.subgroup;
    }
    getValueAddedTax() {
        return this.valueAddedTax;
    }
    setValueAddedTax(valueAddedTax) {
        this.valueAddedTax = valueAddedTax;
    }
    getVehicle() {
        return this.vehicle;
    }
    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsSelected(isSelected) {
        this.isSelected = isSelected;
    }
    getBmwPartsOrderingNumber() {
        return this.bmwPartsOrderingNumber;
    }
    setBmwPartsOrderingNumber(bmwPartsOrderingNumber) {
        this.bmwPartsOrderingNumber = bmwPartsOrderingNumber;
    }
}
//# sourceMappingURL=partV11.js.map